import React from "react";
import styled from "@emotion/styled";
import DefaultLayout from "../../containers/layouts";
import { Grid, Typography } from "@mui/material";
import { Email, Phone } from "@mui/icons-material";
import SupportIcon from "@mui/icons-material/Support";

function Support() {
  return (
    <DefaultLayout>
      <Header></Header>
      <div style={{ padding: "16px", textAlign: "left" }}>
        <Typography variant="h5" gutterBottom>
          <SupportIcon fontSize="small"></SupportIcon> PET Support für EEVIE
        </Typography>
        <Typography variant="body1" paragraph>
          Falls Sie Hilfe zu EEVIE benötigen, können Sie den PET Support hier
          erreichen:
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" component="div">
              <Phone fontSize="small" style={{ verticalAlign: "middle" }} />
              <strong> Telefon:</strong> 0841-89-42042
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" component="div">
              <Email fontSize="small" style={{ verticalAlign: "middle" }} />
              <strong> E-Mail:</strong> 42042@audi.de
            </Typography>
          </Grid>
        </Grid>
      </div>
    </DefaultLayout>
  );
}
export default Support;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
